import { CellChangeArg } from "~app/common/components/hot-doc/hotdoc/cell";
import { IMarkningValue } from "./markingValue";

export class FargCellChangeArg extends CellChangeArg {
    readonly newValue: IMarkningValue;
    constructor(raw: IMarkningValue, readonly onComplete: () => void) {
        super(raw, raw, onComplete);
    }
}
